import React from "react";
import { Tooltip } from "@mui/material";
import styles from "./index.module.scss";
import search from "../../../../assets/images/search.svg";
import clearIcon from "../../../../assets/images/close-icon.svg";

import { SidebarItemState } from "../../../../types/seatApproval";
import { SortState } from "../../../../types/seatApproval"; 
import { ApprovalStatus, dropDownnJSON } from "../../../../constants/textConstants";

interface ToolBarProps {
  selectedOption: {
    label: string;
    value: string | number;
    data: any;
  };
  isDropdownOpen: boolean;
  searchText: string;
  searchValue: { open: boolean; value: string };
  sessions: any[];
  kpis: any[];
  setIsDropdownUserList: (value: boolean) => void;
  setSelectedOption: (option: any) => void;
  setDropdownAllocatedSessionId: (id: any) => void;
  setIsDropdownOpen: (value: boolean) => void;
  loadUsers: (
    offset: number,
    reset: boolean,
    appliedfilters?: any,
    filterItem?: any,
  ) => void;
  setSelectedSidebarItem: (value: SidebarItemState) => void;
  handleDropdownSessionSelect: (session: any) => void;
  setIsSortDropdownOpen: (value: boolean) => void;
  setSortState: (value: SortState) => void;
}

export const PreferenceMobileScroll: React.FC<ToolBarProps> = ({
  selectedOption,
  sessions,
  setIsDropdownUserList,
  setSelectedOption,
  setDropdownAllocatedSessionId,
  loadUsers,
  setSelectedSidebarItem,
  handleDropdownSessionSelect,
  setIsSortDropdownOpen,
  setSortState,
  kpis,
}) => {
    const resetSort = () => {
    setSortState({ sortKey: "", sortOrder: "asc" }); 
    setIsSortDropdownOpen(false);
  }; 
 const kpiCounts = {
  all: (kpis?.allKpis?.totalRegistrations ?? 0).toString().padStart(2, "0"),
  hold: (kpis?.allocated?.totals?.rejectCount?.value ?? 0).toString().padStart(2, "0"),
  ytd: (kpis?.allocated?.totals?.holdCount?.value ?? 0).toString().padStart(2, "0"),
  unassigned: (kpis?.unallocated?.totals?.totalUnallocatedCount?.value ?? 0).toString().padStart(2, "0"),
  swapRequests: (
    ((kpis?.swapRequests?.find((item: any) => item.kpiName === "male")?.count ?? 0) +
      (kpis?.swapRequests?.find((item: any) => item.kpiName === "female")?.count ?? 0))
  ).toString().padStart(2, "0"),
};
  const handleAllClick = () => {
    resetSort();
    setIsDropdownUserList(false);
    setSelectedOption({
      label: "All",
      value: "all",
      data: "",
    });
    setDropdownAllocatedSessionId(null);
    setSelectedSidebarItem({
      key: "total",
      kpiCategory: "all",
      kpiFilter: "all",
    });
    loadUsers(
      0,
      true,
      {},
      {
        kpiFilter: "all",
        approvalStatus: "all",
        sortKey: "",
        sortOrder: "asc",
      },
    );
  };

  const handleUnassignedClick = () => {
    resetSort();
    setIsDropdownUserList(false);
    setSelectedOption({
      label: "Unassigned",
      value: "registered",
      data: "",
    });
    setSelectedSidebarItem({
      key: "total_unallocated",
      kpiCategory: "unallocated",
      kpiFilter: "total_unallocated",
    });
    setDropdownAllocatedSessionId(null);
    loadUsers(
      0,
      true,
      {},
      {
        kpiFilter: "total_unallocated",
        approvalStatus: "unallocated",
        sortKey: "",
        sortOrder: "asc",
      },
    );
  };

  const handleSessionClick = (session: any) => {
    resetSort();
    handleDropdownSessionSelect(session);
    setIsDropdownUserList(false);
    setSelectedOption({
      label: session.name,
      value: session.type,
      data: session,
    });
    setDropdownAllocatedSessionId(session.id);
    if (session.name === "Hold" || session.name === "YTD") {
      setSelectedSidebarItem({
        key: `${session.type}_total`,
        kpiCategory: session.kpiCategory,
        kpiFilter: session.kpiFilter,
      });
      setDropdownAllocatedSessionId(null);
    } else {
      setDropdownAllocatedSessionId(session.id);
      setSelectedSidebarItem({
        key: `${session.kpiFilter}_total`,
        kpiCategory: session.kpiCategory,
        kpiFilter: session.kpiFilter,
      });
    }
    loadUsers(
      0,
      true,
      {},
      {
        kpiFilter: session.kpiFilter,
        approvalStatus: session.kpiCategory,
      },
    );
  };

  const handleSwapRequestClick = () => {
    resetSort();
    handleDropdownSessionSelect("Swap Request");
    // setIsDropdownUserList(true);
    setSelectedOption({
      label: "Swap",
      value: "swap requests",
      data: "",
    });
    setSelectedSidebarItem({
      key: "swap_total",
      kpiCategory: "all",
      kpiFilter: "swap-requests",
    });
    setDropdownAllocatedSessionId(null);
    setIsDropdownUserList(false);
    setSelectedSidebarItem({
      key: "swap_total",
      kpiCategory: "all",
      kpiFilter: "swap-requests",
    });
    loadUsers(
      0,
      true,
      {},
      {
        kpiFilter: "swap-requests",
        approvalStatus: "all",
        swapRequests: "wants_swap",
      },
    );
  };
  const handleCancelledRequestClick = () => {
    resetSort();
    handleDropdownSessionSelect("Cancelled");
    // setIsDropdownUserList(true);
    setSelectedOption({
      label: "Cancelled",
      value: "cancelled",
      data: "",
    });
    setSelectedSidebarItem({
      key: "cancelled_total",
      kpiCategory: "cancelled",
      kpiFilter: "cancelled",
    });
    setDropdownAllocatedSessionId(null);
    setIsDropdownUserList(false);
    setSelectedSidebarItem({
     key: "cancelled_total",
      kpiCategory: "cancelled",
      kpiFilter: "cancelled",
    });
    loadUsers(
      0,
      true,
      {},
      {
        kpiFilter: "cancelled",
        approvalStatus: "cancelled",
      },
    );
  };

  const isSelected = (value: string) => {
    return (
      selectedOption?.value === value ||
      selectedOption?.label?.toLowerCase() === value.toLowerCase()
    );
  };
  return (
    <div className={styles.toolbarContainer}>
      <div className={styles.horizontalScrollContainer}>
        <div className={styles.scrollableContent}>
          <div
            className={`${styles.horizontalItem} ${
              isSelected("all") ? styles.selectedItem : ""
            }`}
            onClick={handleAllClick}
          >
            <p>{kpiCounts.all}</p>
            <p>{dropDownnJSON.ALL.label}</p>
          </div>
          <div
            className={`${styles.horizontalItem} ${isSelected("registered") || isSelected("Unassigned") ? styles.selectedItem : ""}`}
            onClick={handleUnassignedClick}
          >
            <p className={styles.kpiCount}>{kpiCounts.unassigned}</p>
            <p>{dropDownnJSON.UNASSIGNED.label}</p>
          </div>
            {sessions.map((session) => {
            // Find the matching program by programId === session.id
            const matchedProgram = kpis?.allocated?.programs?.find(
              (program: any) => program.programId === session.id
            );
            return (
              <div
                key={session.id}
                className={`${styles.horizontalItem} ${
                  isSelected(session.name) ? styles.selectedItem : ""
                }`}
                onClick={() => handleSessionClick(session)}
              >
                {session.name !== ApprovalStatus.HOLD && session.name !== ApprovalStatus.YTD
                  ? <>
                    <p>
                      {`${(matchedProgram?.allocatedCount ?? 0).toString().padStart(2, "0")}`}
                    </p>
                    <p>{`${session.name}`}</p>
                  </>
                  : session.name === ApprovalStatus.HOLD
                  ? <><p>{kpiCounts.hold}</p><p>{ApprovalStatus.HOLD}</p></>
                  : session.name === ApprovalStatus.YTD
                  ? <><p>{kpiCounts.ytd}</p><p>{ApprovalStatus.YTD}</p></>
                  : ""}
              </div>
            );
          })}
          <div
          className={`${styles.horizontalItem} ${
            isSelected("swap requests") || isSelected("Swap") ? styles.selectedItem : ""
          }`}
          onClick={handleSwapRequestClick}
        >
      <p>
          {(kpiCounts?.swapRequests ?? 0)
            .toString()
            .padStart(2, "0")}
        </p>            
       <p>{dropDownnJSON.SWAP_REQUESTS.label}</p> 
          </div>
          <div
          className={`${styles.horizontalItem} ${
            isSelected("cancelled") ? styles.selectedItem : ""
          }`}
          onClick={handleCancelledRequestClick}
        >
           <p>
              {(kpis?.cancelledKpis?.totalCancelledRegistrations ?? 0)
                .toString()
                .padStart(2, "0")}
           </p>            
           <p>{dropDownnJSON.CANCELLED.label}</p> 
          </div>
        </div> 
      </div>
    </div>
  );
};
